import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { BadgeModule } from '../../badge/badge.module';
import { CircularProgressIndicatorModule } from '../../circular-progress-indicator/circular-progress-indicator.module';
import { IconModule } from '../../icon/icon.module';
import { SpinnerModule } from '../../spinner/spinner.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { SegmentedControlButtonComponent } from './segmented-control-button.component';

@NgModule({
  declarations: [SegmentedControlButtonComponent],
  exports: [SegmentedControlButtonComponent],
  imports: [
    CommonModule,
    IconModule,
    I18nModule,
    SpinnerModule,
    CircularProgressIndicatorModule,
    TooltipModule,
    BadgeModule,
  ],
})
export class SegmentedControlButtonModule {}
export {
  LanguageSwitcherItem,
  SegmentedControlButtonComponent,
  segmentedButtonType,
} from './segmented-control-button.component';
